import React from 'react';
import { Link } from 'react-router-dom';
import { CONTENT_HUBS, HUB_ORDER } from '../../data/contentHubs';
import { Activity, HeartPulse, Baby, Dumbbell, ArrowRight, Compass } from 'lucide-react';

const ICONS = { Activity, HeartPulse, Baby, Dumbbell };

const HubCardsSection = () => (
  <section id="health-hubs" className="py-16 sm:py-20 lg:py-24 relative overflow-hidden bg-slate-950" data-testid="hub-cards-section">
    <div className="absolute top-0 right-1/4 w-80 h-80 bg-emerald-600/10 rounded-full blur-3xl" aria-hidden="true"></div>
    <div className="container mx-auto px-4 sm:px-6 relative z-10">
      <div className="text-center mb-10 sm:mb-14 max-w-3xl mx-auto">
        <span className="inline-flex items-center gap-2 px-4 py-2 bg-emerald-500/10 border border-emerald-500/30 rounded-full text-emerald-400 text-sm font-medium mb-4">
          <Compass className="w-4 h-4" aria-hidden="true" />
          Explore by Focus
        </span>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">
          Find Your <span className="bg-gradient-to-r from-emerald-400 to-cyan-400 bg-clip-text text-transparent">Health Hub</span>
        </h2>
        <p className="text-slate-400 text-sm sm:text-base">
          Pick the area that matters most to you. Each hub connects our programs, doctor-written guides and free tools in one place.
        </p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 max-w-6xl mx-auto">
        {HUB_ORDER.map((slug) => {
          const h = CONTENT_HUBS[slug];
          const Icon = ICONS[h.icon] || Activity;
          return (
            <Link
              key={slug}
              to={`/hub/${slug}`}
              className="group relative bg-slate-900/60 border border-slate-800 hover:border-slate-600 rounded-2xl p-6 transition-all overflow-hidden"
              data-testid={`home-hub-card-${slug}`}
            >
              <div className={`absolute -top-10 -right-10 w-32 h-32 rounded-full blur-3xl bg-gradient-to-br ${h.gradient} opacity-10 group-hover:opacity-20 transition-opacity`} aria-hidden="true"></div>
              <div className={`relative w-12 h-12 rounded-2xl ${h.badgeBg} border ${h.badgeBorder} flex items-center justify-center ${h.accent} mb-4`}>
                <Icon className="w-6 h-6" aria-hidden="true" />
              </div>
              <h3 className="relative text-lg font-bold text-white mb-2 leading-snug">{h.title}</h3>
              <p className="relative text-slate-400 text-sm leading-relaxed mb-4">{h.intro.split('.')[0]}.</p>
              <span className={`relative inline-flex items-center gap-1.5 ${h.accent} text-sm font-semibold`}>
                Explore hub
                <ArrowRight className="w-4 h-4 -translate-x-1 group-hover:translate-x-0 transition-transform" aria-hidden="true" />
              </span>
            </Link>
          );
        })}
      </div>
    </div>
  </section>
);

export default HubCardsSection;
